import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    LoadingIndicator,
} from '@/components/v4';

const ModalCopy = ({
    children,
    type,
    name,
    handleClose,
    handleSubmit,
    closeWalkthroughId,
    deleteWalkthroughId,
    isDisabled,
    isLoading,
    isSaving,
    isOpen,
    isCentered = false,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={handleClose} isCentered={isCentered}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    Copy {type}: {name}
                </ModalHeader>
                <ModalBody>
                    {isLoading ? (
                        <LoadingIndicator />
                    ) : (
                        <>
                            <Text fontWeight="bold">Copy as</Text>
                            {children}
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={isDisabled || isSaving}
                        mr={3}
                        variant="outline"
                        onClick={() => handleClose()}
                        data-walkthroughid={closeWalkthroughId}
                        minW="100px">
                        Cancel
                    </Button>
                    <Button
                        isDisabled={isDisabled || isSaving}
                        variant="solid"
                        isLoading={isSaving}
                        loadingText="Copying"
                        onClick={() => handleSubmit()}
                        data-walkthroughid={deleteWalkthroughId}
                        minW="100px">
                        Copy
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalCopy;
